import { Container, Stack } from "@mui/material";
import { East as RightArrowIcon } from "@mui/icons-material";

import ButtonText from "../../component/Button/Text";

const TopBar = ({ view, setView }) => (
  <Container maxWidth="large">
    <Stack
      py={2}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
    >
      <Link
        title="bytez"
        selected={0 === view}
        onClick={() => setView(0)}
        sx={{
          fontWeight: 700,
          typography: "brand",
          fontSize: { compact: 24, expanded: 32 }
        }}
      />

      <Stack
        spacing={1}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        width={{ compact: "unset", lg: "50%" }}
      >
        <Stack
          spacing={1}
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          {["Agent", "API"].map((title, index) => (
            <Link
              key={title}
              title={title}
              selected={index + 1 === view}
              onClick={() => setView(index + 1)}
            />
          ))}
        </Stack>
        <Link
          title="Try now"
          href="/"
          Icon={() => <RightArrowIcon sx={{ ml: 1, height: 24, width: 24 }} />}
        />
      </Stack>
    </Stack>
  </Container>
);
export default TopBar;
export const Link = ({ title, onClick, href, Icon, selected, sx }) => (
  <ButtonText
    label={title}
    onClick={onClick}
    href={href}
    IconEnd={Icon}
    sx={{
      px: { compact: 1, expanded: 3 },
      typography: {
        compact: "bodyMd",
        expanded: "headlineSm"
      },
      color: selected ? "dark.tertiary.color" : "dark.primary.color",
      "&:hover": {
        color: "dark.tertiary.color"
      },
      ...sx
    }}
  />
);
